import history from 'App/pages/routes/history';

/**
 * Legacy Angular list pages read their filter from the URL only when the state is entered,
 * and ?q= is not part of the state URL — so if we're already on the destination path, only
 * a full reload applies the new filter.
 */
export const goToListRoute = (href: string) => {
	const normalize = (path: string) => path.replace(/\/$/, '');
	const targetPath = normalize(href.slice(href.indexOf('#')).split('?')[0]);
	const currentPath = normalize(window.location.hash.split('?')[0]);
	window.location.href = href;
	if (currentPath === targetPath) {
		window.location.reload();
	}
};

/**
 * The React ListView pages re-read ?f= from the URL while mounted
 * (ListView.componentDidUpdate), so pushing through the router's own history is enough — a
 * reload is only needed when the URL wouldn't change at all, which no listener picks up.
 * `to` is the route without the '#' prefix, e.g. '/activities?f=...'.
 */
export const goToReactListRoute = (to: string) => {
	const decode = (value: string) => {
		try {
			return decodeURIComponent(value);
		} catch {
			return value;
		}
	};
	const current = window.location.hash.replace(/^#/, '');
	history.push(to);
	if (decode(current) === decode(to)) {
		window.location.reload();
	}
};
